import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ProjectDataProductoTypeModelo } from 'src/app/entities/project-data-producto-type-modelo.interface';
import { ProjectDataProductoTypePanel } from 'src/app/entities/project-data-producto-type-panel.interface';
import { ProjectDataPuerta } from 'src/app/entities/project-data-puerta.entity';
import { Subscription, of } from 'rxjs';
import { ModelService } from 'src/app/services/model.service';
import { CatalogService } from 'src/app/services/catalog.service';
import { flatMap } from 'rxjs/operators';
// import { CarouselItemComponent } from '../../carousel-item/carousel-item.component';
import { DB } from 'src/app/datas/db';
import { ProjectData } from 'src/app/entities/project-data.entity';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { element, error } from 'protractor';
import { ProjectListService } from 'src/app/admin/project-list/project-list.service';

@Component({
	selector: 'app-door-picker',
	templateUrl: './door-picker.component.html',
	styleUrls: ['./door-picker.component.scss']
})
export class DoorPickerComponent implements OnInit, OnDestroy {

	@Input() product: ProjectDataProductoTypeModelo;
	@Input() data: ProjectDataPuerta;
	@Input() isDisabled: boolean = false;
	@Input() panel: ProjectDataProductoTypePanel;
	@Input() projectData: ProjectData;

	@Input() carousel: boolean;
	@Input() method: string;
	@Input() label: string;
	@Input() noSelectionMessage: string;
	@Input() selectedItemId: string;
	@Input() settingItems: any[] = new Array();
	@Input() disabled: boolean;
	@Input() tipoPanel_id: string;
	@Input() alturaPanel: any;

	@Output() remove: EventEmitter<any> = new EventEmitter();
	@Output() selectevent: EventEmitter<object> = new EventEmitter<object>();
	@Output() errorDoorPdf: EventEmitter<any> = new EventEmitter();

	@ViewChildren('CarouselItemComponen') items: QueryList<DoorPickerComponent>;

	@ViewChild('holder', { static: false }) carouselHolder: ElementRef;
	@ViewChild('contents', { static: false }) carouselContents: ElementRef;

	@ViewChild('itemView', { static: false }) public itemView: ElementRef;

	@Input() id: number;
	@Input() name: string;
	@Input() background: string;
	@Input() index: number;
	@Input() selected: boolean;

	public listadoModelosPuertas: any[] = [];
	public listadoTiposPuertas: any[] = [];
	public listadoPuertas: any[] = [];
	public listadoBayonetas: any[] = [];
	public objetIdModeloPuerta: any;
	public modeloPuerta:any;
	public alturaValorPuerta:any;
	public puertaSelecionada:any;
	public medidaPuertaSeleccionada :string;

	private subscriptions: Subscription[] = [];

	private onCategoryLoad: Subscription;

	public currentPosition: number = 0;

	private lastMouseXPosition: number = 0;
	private lastMouseYPosition: number = 0;

	public leftButtonEnabled: boolean = false;
	public rightButtonEnabled: boolean = true;

	private keyboardMode: boolean = false;
	public hasScroll: boolean = false;
	public initialized: boolean = false;

	private cardMargin: number = 20;

	public db = new DB();
	public errorPuertaPdf : boolean = false;

	constructor(
		public modelService: ModelService,
		private catalogService: CatalogService,
		private http: HttpClient,
		private projectListService : ProjectListService,
		private cref: ChangeDetectorRef) { }

	public ngOnInit() {
		this.initialize();
	}
	public ngOnChanges(){
		this.errorPuertaPdf = false;
	}

	public ngOnDestroy() {
		this.subscriptions.map((item: Subscription) => { item.unsubscribe(); });
	}

	/* Inicializa el componente para el JSON actual */
	public initialize() {
		if (this.product && this.product._id) {

			this.catalogService.getModelosPuertas(this.product._id)
				.pipe(
					flatMap((rsModelosPuertas: any) => {
						this.listadoModelosPuertas = [];
						rsModelosPuertas.result.forEach((element: any) => { this.listadoModelosPuertas.push(element); });

						
						//TO-DO: Incluir en la tabla de modelopuertas el parametro order. Implementar para todos los documentos.
						/*
						let filtered1 = this.listadoModelosPuertas.filter(puerta => !puerta.idUnity.includes('DESLIZANTE'));
						let compare = (a,b) => {
							if ( a.order < b.order ){
							  return -1;
							}
							if ( a.order > b.order ){
							  return 1;
							}
							return 0;
						}  
						filtered1.sort( compare );

						let filtered2 = this.listadoModelosPuertas.filter(puerta => puerta.idUnity.includes('DESLIZANTE'));
						this.listadoModelosPuertas = [];
						this.listadoModelosPuertas = filtered1.concat(filtered2);
						*/
						let compare = (a,b) => {
							if ( a.order < b.order ){
							  return -1;
							}
							if ( a.order > b.order ){
							  return 1;
							}
							return 0;
						}  
						this.listadoModelosPuertas.sort( compare );
						
						if (!this.data.idModeloPuerta) { return of({ result: [] }); }
						return this.catalogService.getTiposPuertas(this.data.idModeloPuerta);
					}),
					flatMap((rsTiposPuertas: any) => {
						this.listadoTiposPuertas = [];
						rsTiposPuertas.result.forEach((element: any) => { this.listadoTiposPuertas.push(element); });
						if (!this.data.idTipoPuerta) { return of({ result: [] }); }
						return this.catalogService.getPuertas(this.data.idTipoPuerta);
					}),
					flatMap((rsPuertas: any) => {
						this.listadoPuertas = [];
						rsPuertas.result.forEach((element: any) => { this.listadoPuertas.push(element); });
						return of({ result: [] });
					})
				)
				.subscribe(() => {
					this.recuperaBayonetas();
					this.cref.markForCheck();
				});
		}
	}

	/**
	 * Recupera de servidor los modelos de puerta asociados a un modelo de vallado
	 * @param objModeloPanel - JSON con la información del modelo. En su ausencia se recupera el ID almacenado a nivel de proyecto
	 */

	public recuperaModelosPuertas(objModeloPanel: any): void {
		this.data.idModeloPanel = objModeloPanel._id;

		// Llamada para las puertas asociadas a este tipo de panel
		this.catalogService.getModelosPuertas(objModeloPanel._id).subscribe((rs) => {
			this.listadoModelosPuertas.splice(0);
			this.listadoTiposPuertas.splice(0);
			this.listadoPuertas.splice(0);

			this.data.idModeloPuerta = undefined;
			this.data.idTipoPuerta = undefined;
			this.data.idPuerta = undefined;
			this.data.puerta = undefined;
			this.data.alturaPuerta = undefined;
			this.data.bayoneta = undefined;

			rs.result.forEach((element: any) => {
				this.listadoModelosPuertas.push(element);
			});

			// /*
			// //TO-DO: Incluir en la tabla de modelopuertas el parametro order. Implementar para todos los documentos.
			/*
				let filtered1 = this.listadoModelosPuertas.filter(puerta => !puerta.idUnity.includes('DESLIZANTE'));
				let compare = (a,b) => {
					if ( a.order < b.order ){
						return -1;
					}
					if ( a.order > b.order ){
						return 1;
					}
					return 0;
				}  
				filtered1.sort( compare );

				let filtered2 = this.listadoModelosPuertas.filter(puerta => puerta.idUnity.includes('DESLIZANTE'));
				this.listadoModelosPuertas = [];
				this.listadoModelosPuertas = filtered1.concat(filtered2);
			*/
			let compare = (a,b) => {
				if ( a.order < b.order ){
				  return -1;
				}
				if ( a.order > b.order ){
				  return 1;
				}
				return 0;
			}  
			this.listadoModelosPuertas.sort( compare );

		});

	}

	public recuperaTiposPuertas(objModeloPuerta: any, i: any): void {		

		this.objetIdModeloPuerta = objModeloPuerta._id;
		this.onSelect(i);
		this.data.idModeloPuerta = objModeloPuerta._id;
		this.recuperaPuertas(objModeloPuerta._id);
		this.errorPuertaPdf = false;
		
	}

	public recuperaPuertas(objModeloPuerta: any): void {
		let tipoPuerta = this.db.tipoPuerta(objModeloPuerta);
		if (!this.panel) this.panel = JSON.parse(localStorage.getItem('panel'));
		this.data.idTipoPuerta = tipoPuerta[0]._id;

		//this.panel.alturaValor = 0;
		var maxAltura = (this.panel.alturaValor > 2000) ? 2000 : this.panel.alturaValor;
		this.catalogService.getPuertas(this.data.idTipoPuerta).subscribe((rs) => {
			this.listadoPuertas.splice(0);
			this.data.idPuerta = undefined;
			this.data.puerta = undefined;
			this.data.alturaPuerta = undefined;
			this.data.bayoneta = undefined;
			this.data.alturaValor = undefined;

			rs.result.forEach((element: any) => {
				if (maxAltura <= element.alturaValor){
					this.listadoPuertas.push(element);
				}

			});

			this.recuperaBayonetas();
			this.cref.markForCheck();
		});
	}

	public recuperaBayonetas(): void {
		this.catalogService.getBayonetasPuertas().subscribe((rs) => {
			this.listadoBayonetas.splice(0);
			this.data.bayoneta = undefined;
			rs.result.forEach((element: any) => {
				// solo bayonetas para puertas
				if (element.modeloPuerta) this.listadoBayonetas.push(element);
			});
			this.cref.markForCheck();
		});
	}

	public seleccionaPuerta(): void {

		this.data.puerta = this.listadoPuertas.find((item: any) => {
			this.alturaValorPuerta = item.alturaValor
			
			return item._id === this.data.idPuerta;
		}, this);
		this.data.bayoneta = this.seleccionaBayoneta();
		this.errorPuertaPdf = false;
		this.puertaSelecionada = this.data.puerta;
		return this.alturaValorPuerta;

	}
	public selecctionPuerta(dataId){
		for(let i=0; i < this.listadoPuertas.length;i++){
			if(this.listadoPuertas[i]._id === dataId){
				let posicion = this.listadoPuertas[i];
			}
		}

	}
	

// ########### ESPRIVISA-43 ##############
	public clickSeleccionaPuerta(){
		if(this.objetIdModeloPuerta === undefined){
			this.objetIdModeloPuerta = this.data.idModeloPuerta;
		}
		this.recuperaPuertas(this.objetIdModeloPuerta)
		this.alturaValorPuerta;
	}
// ############# ESPRIVISA-43 ###############

	public seleccionaBayoneta(): any {
		return this.listadoBayonetas.find((bayoneta: any): boolean => {
			return this.data.puerta.hojas === bayoneta.hojas &&
				this.panel.color[0] === bayoneta.color &&
				bayoneta.modeloPuerta.includes(this.data.idModeloPuerta);
		});
	}

	public eliminaPuerta(): void {
		this.remove.emit(true);
	}

	// carousel.component.ts

	public onSelect(selectedIndex: any) {
		if (!this.disabled) {

			console.log(this.settingItems[selectedIndex]);

			this.selectevent.emit(this.settingItems[selectedIndex]);

			this.selectItem(selectedIndex);
		}
	}

	get countItems(): number {
		return this.settingItems.length || 0;
	}

	get countMaxVisibleElements(): number {
		return this.carouselHolder.nativeElement.clientWidth / this.cardWidth;
	}

	get cardWidth(): number {
		const firstCard: ElementRef = this.items.first.itemView;
		const cardOffsetWidth: number = firstCard.nativeElement.offsetWidth;

		return cardOffsetWidth + this.cardMargin;
	}

	get maxPosition(): number {
		return Math.abs(this.carouselHolder.nativeElement.clientWidth -
			this.carouselContents.nativeElement.scrollWidth);
	}

	get currentScrollWidth(): number {
		return this.carouselContents.nativeElement.scrollWidth;
	}

	public checkScroller(): void {
		//as soon as current thread ends
		setTimeout(() => {
			if (this.carouselContents) {
				this.hasScroll = this.carouselHolder.nativeElement.clientWidth <
					this.carouselContents.nativeElement.scrollWidth;
				this.initialized = true;
			}
			this.currentPosition = 0;
		}, 0);
	}

	slideLeft(): void {
		// regular position to slide to
		let slideToPosition: number = Math.max(this.currentPosition - this.cardWidth, 0);
		// check if another iteration is posible
		let futureFirstPosition: number = slideToPosition - (this.cardWidth - this.cardMargin);

		// set current position acording to conditions
		this.currentPosition = (futureFirstPosition < 0) ? 0 : slideToPosition;
		this.leftButtonEnabled = this.currentPosition > 0;
		this.rightButtonEnabled = true;
	}

	slideRight(): void {

		// regular position to slide to
		let slideToPosition: number = this.currentPosition + this.cardWidth;

		// check if another iteration is posible
		let futureLastPosition: number = slideToPosition + (this.cardWidth - this.cardMargin);

		// set current position acording to conditions
		if (futureLastPosition > this.maxPosition) {
			this.currentPosition = this.maxPosition;
		} else {
			this.currentPosition = slideToPosition;
		}

		// right button is enabled only if future slide position is inside bounds
		this.rightButtonEnabled = futureLastPosition < this.maxPosition;
		this.leftButtonEnabled = true;

	}

	/**
	 *  Handles resizing of element
	 */
	onResize(event: Event): void {
		// only in case that currentposition is greater than maxPosition
		if (this.carouselContents) {
			if (this.currentPosition > this.maxPosition) {
				this.currentPosition = this.maxPosition;
				this.rightButtonEnabled = false;
			}
		}
		this.checkScroller();
	}

	/**
	 * Checks if user has moved the mouse, and sets keyboard mode to category-items
	 */
	setMouseMode(event: MouseEvent): void {
		// mouse position has changed
		if (event.clientX !== this.lastMouseXPosition
			|| event.clientY !== this.lastMouseYPosition) {
			this.lastMouseXPosition = event.clientX;
			this.lastMouseYPosition = event.clientY;
		}
	}

	private selectItem(selectedIndex) {
		this.items.map((item) => {
			item.selected = false;
			if (item.index === selectedIndex) {
				item.selected = true;
			}
		});
	}
	//ESPRIVISA-36
	public downloadModelPDF() {
		 if(this.data.puerta.idUnity){
		this.errorPuertaPdf = false;
		this.http.get('/assets/pdf/' + this.data.puerta.idUnity + '.pdf',
				{ responseType: 'blob' }).subscribe((data) => {
					const blob = new Blob([data], { type: 'application/pdf' });
					const url = window.URL.createObjectURL(blob);
					window.open(url);
					return;
				},(error:HttpErrorResponse)=>{
					this.errorPuertaPdf = true;
					setTimeout(()=>{
						this.errorPuertaPdf = false;
					},4000)
					return;
				});		
	}

	}
	//ESPRIVISA-36
}
